import {
   View,
   Text,
   Platform,
   TouchableOpacity,
   Image,
   StyleSheet,
} from 'react-native';
import React, {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {
   selectLandscapeSmallWebView,
   selectScreenOrientation,
} from '../../redux/slices/ScreenOrientationSlice';
import {WHITE_ICON_HOVER_TINT_COLOR, white} from '../../utils/utils';
import Slider from '../../components/slider';
import {selectAslVolume, setVolume} from '../../redux/slices/AslSlice';

const ASLVolume = () => {
   const dispatch = useDispatch();
   const [showVolumeBar, setShowVolumeBar] = useState(false);
   const [isVolumeIconHover, setVolumeIconHover] = useState(false);
   const isTablet = useSelector(selectScreenOrientation);
   const isLandscapeMode = useSelector(selectScreenOrientation);
   const marginAndSize = {
      height: isTablet ? 25 : 25,
      width: isTablet ? 25 : 25,
      marginRight: 8,
   };
   const isWeb = Platform.OS === 'web';
   const isWindows = Platform.OS === 'windows';
   const isMacos = Platform.OS === 'macos';
   const isLandscapeSmallWebView = useSelector(selectLandscapeSmallWebView);
   const volume = useSelector(selectAslVolume);
   const onVolumeChage = v => {
      const volume = v === 0 ? 0.01 : v;
      dispatch(setVolume(volume));
   };
   return (
      <View
         style={{
            flex: 1,
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'flex-start',
            top: 5,
         }}>
         <TouchableOpacity
            onMouseEnter={() => {
               setVolumeIconHover(true);
            }}
            onMouseLeave={() => {
               setVolumeIconHover(false);
            }}
            onPress={() => setShowVolumeBar(!showVolumeBar)}>
            <View
               style={[
                  styles.roundView2,
                  marginAndSize,
                  {
                     marginLeft: 8,
                  },
               ]}>
               <Image
                  source={require('../../assets/volume.png')}
                  style={{
                     height: isTablet ? 12 : 12,
                     width: isTablet ? 12 : 12,
                     tintColor: isVolumeIconHover
                        ? WHITE_ICON_HOVER_TINT_COLOR
                        : white,
                  }}
               />
            </View>
         </TouchableOpacity>
         {showVolumeBar && (
            <View>
               <Slider
                  style={{
                     width: 80,
                     height: 5,
                     padding: 0,
                     marginStart: 0,
                     ...Platform.select({
                        web: {
                           cursor: 'pointer',
                           marginTop: 10,
                        },
                     }),
                  }}
                  value={volume}
                  minimumValue={0}
                  maximumValue={1}
                  {...(!isWeb && {
                     onValueChange: value => onVolumeChage(value),
                  })}
                  {...(isWeb && {
                     onSlidingComplete: value => onVolumeChage(value),
                  })}
                  thumbStyle={{height: 15, width: 15}}
                  thumbTouchSize={{width: 30, height: 30}}
                  minimumTrackTintColor="#6E8EFF"
                  maximumTrackTintColor="#585858"
                  trackStyle={{
                     borderRadius: 2,
                     backgroundColor: '#585858',
                  }}
                  thumbTintColor="#6E8EFF"
               />
            </View>
         )}
      </View>
   );
};
const styles = StyleSheet.create({
   bottomView: {
      flexDirection: 'row',
      alignContent: 'center',
      paddingVertical: 10,
      alignItems: 'center',
      width: '100%',
      justifyContent: 'space-between',
   },

   roundView2: {
      alignItems: 'center',
      justifyContent: 'center',
      padding: 8,
      borderRadius: 50,
      backgroundColor: '#313131',
   },

   controlView: {
      height: 20,
      width: 20,
      marginRight: 16,
      alignItems: 'center',
      justifyContent: 'center',
      padding: 4,
      borderRadius: 50,
      position: 'absolute',
      backgroundColor: '#101010',
   },
   videoView: {
      flex: 1,
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
   },
});
export default ASLVolume;
